import { CmsComponentProps } from '@/types/cms';
import { FC } from 'react';

const Block: FC<CmsComponentProps> = ({ properties = {}, ...props }) => {
  return (
    <div
      aria-hidden="true"
      tabIndex={-1}
      data-module={props.cmsComponentKey}
      style={{
        height: properties.block_height + 'px'
      }}></div>
  );
};

export default Block;
